import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { Item } from 'Components/Grid';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import HistorySection from 'Components/HistorySection';
import InfoPopover from 'Components/InfoPopover';
import DocumentCreationButton from 'Components/DocumentCreationButton';
import { uhdrsFunctionalAssessment } from 'neuro-schemas';
import { formatPartialDate } from 'Utility/date';

const { calculateScore } = uhdrsFunctionalAssessment;

const UHDRSFunctionalAssessment = ({ documents, startEdit, view }: IOwnProps): React.JSX.Element => (
  <HistorySection
    headerText={<FormattedMessage id="functionalPerformance.uhdrsFunctionalAssessment" />}
    newButton={
      <DocumentCreationButton
        name="uhdrsFunctionalAssessment"
        text="functionalPerformance.newUhdrsFunctionalAssessment"
        onClick={startEdit({}, 'uhdrsFunctionalAssessment')}
        width={20}
        height={3}
        fontSize={14}
        alternate={true}
      />
    }
  >
    <HistoryRowListing
      documents={documents}
      headers={
        <>
          <Item xs={2}>
            <FormattedMessage id="general.date" />
          </Item>
          <Item xs={2}>
            <FormattedMessage id="functionalPerformance.labels.uhdrsFunctionalAssessment.score" />
          </Item>
          <Item xs={8}>&nbsp;</Item>
        </>
      }
      contentFormat={d => (
        <>
          <Item xs={2}>{formatPartialDate(d.date ?? undefined)}</Item>
          <Item xs={2}>{calculateScore(d) ?? <InfoPopover text="general.notFilled" color="primary" />}</Item>
          <Item xs={5}>&nbsp;</Item>
          <Item xs={3}>
            <HistoryRowControls document={d} startEdit={startEdit} view={view} />
          </Item>
        </>
      )}
    />
  </HistorySection>
);

interface IOwnProps {
  documents: Array<IDocumentWithTypeV2<'uhdrsFunctionalAssessment'>>;
  startEdit: StartEdit;
  view?: IView;
}

export default UHDRSFunctionalAssessment;
